var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 312.5 90",
    style: {
      enableBackground: "new 0 0 312.5 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000039102682116778492020000002831692475978756284_);}\r\n\t.st1{fill:#0500FF;}\r\n\t.st4{fill:#ababab;}\r\n\t.st2{fill:url(#SVGID_00000107587171305326917560000010604949930625747082_);}\r\n\t.st3{fill:url(#SVGID_00000173844550513808162560000008724391903668719017_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 15,
    y: 8.1,
    width: 278,
    height: 75.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078022579812760303990000005237479561074418352_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078022579812760303990000005237479561074418352_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,25.9h13.3v7.4c4.3-6.7,9.4-7.4,16.7-7.4V39h-3.3c-8.8,0-13,4.1-13,12.3v14h-13.6V25.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.6,65.3h-13.6v-3.8c-3,3.5-7,5-12,5c-9.5,0-14.9-5.6-14.9-16V25.9h13.6v21.6c0,4.9,2.4,7.7,6.5,7.7 c4.1,0,6.8-2.8,6.8-7.5V25.9h13.6L215.6,65.3L215.6,65.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.9,53.2h12.8c0.6,2.9,2.5,4.1,7.2,4.1c3.8,0,6.1-0.9,6.1-2.6c0-1.3-1.1-2.1-4.2-2.8l-10.3-2.3 c-6.9-1.6-10.4-5.6-10.4-11.9c0-8.4,6.2-12.8,18.1-12.8c12,0,17.8,4.2,18.9,13.3h-12.7c-0.2-2.4-2.7-3.9-6.7-3.9 c-3.3,0-5.4,1-5.4,2.6c0,1.4,1.4,2.4,4.1,3.1l10.8,2.6c7.1,1.7,10.5,5.3,10.5,11.2c0,8.1-7,12.9-19,12.9 C226.8,66.8,218.9,61.6,218.9,53.2L218.9,53.2L218.9,53.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.1,38.2V25.9h-33.6v12.3h10v27.2H284V38.2H294.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5,38.2V25.9h-33.6v12.3h10v27.2h13.6V38.2H137.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,19L49.1,8.1v75.3c-23.9-10-33.5-29.3-33.5-40.2V19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058556010579680671780000004581379656273531813_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.8849,
    y1: -23.8471,
    x2: 114.6486,
    y2: 80.1853,
    gradientTransform: "matrix(0.9524 0 0 -0.9524 -34.114 70.1601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#48FF91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#0094FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#0038FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#0500FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058556010579680671780000004581379656273531813_)"
    },
    d: "M82.6,19L49.1,8.1v75.3 c23.9-10,33.5-29.3,33.5-40.2V19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121975663875936715430000011676917820856323456_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.8357,
    y1: 69.6252,
    x2: 86.293,
    y2: -13.8975,
    gradientTransform: "matrix(0.9524 0 0 -0.9524 -34.114 70.1601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#0094FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#48FF91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#0094FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#0038FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#0500FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121975663875936715430000011676917820856323456_)"
    },
    d: "M82.6,19L49.1,8.1v75.3 c23.9-10,33.5-29.3,33.5-40.2V19z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.10cccc35db0e7e8ec91b8313e6e63892.svg";
export { ForwardRef as ReactComponent };